import { getResultsByIndex } from '../../Algolia/utils/get-results-by-index.js';

function getNbHitsByIndex(allSearchResults, indexName) {
    if (!allSearchResults.length || !indexName) {
        return 0;
    }
    const result = getResultsByIndex(allSearchResults, indexName);
    var ref;
    return (ref = result === null || result === void 0 ? void 0 : result.nbHits) !== null && ref !== void 0 ? ref : 0;
}

export { getNbHitsByIndex };
//# sourceMappingURL=get-hits-by-index.js.map
